import { Button } from "@material-tailwind/react";
import { Avatar, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useSnackbar } from "notistack";
import * as React from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmDialog } from "../../components/component/modals/ConfirmDialog";
import { EditDialog } from "../../components/component/modals/EditModal";
import TableNoData from "../../components/table/TableNoData";
import TableSkeleton from "../../components/table/TableSkeleton";
import { useTheme } from "../../providers/ThemeProvider";
import {
  deleteTestimonial,
  fetchTestimonials,
} from "../../redux/slices/testimonialSlice";
import { EnhancedTableHead } from "./TableHeads";
import { EnhancedTableToolbar } from "./TableToolbar";
import Form from "./TestimonialForm";

export default function EnhancedTable({
  title,
  showFilter = true,
  showSearch = true,
  showAdd = true,
  showPrint = false,
  headCells,
  rows,
  page,
  rowsPerPage,
  setOpenAdd,
  search,
  setSearch,
  refresh,
  setRefresh,
}) {
  // TODO: hooks
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { colors } = useTheme();

  // TODO: useStates
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [selected, setSelected] = React.useState([]);

  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openConfirmModal, setOpenConfirmModal] = React.useState(false);

  const [dataToEdit, setDataToEdit] = React.useState();

  // ======

  // TODO: get the data from slice

  const deleteLoading = useSelector((state) => state.testimonial.isLoading);
  const fetchLoading = useSelector((state) => state.testimonial.fetchLoading);
  const allCategory = useSelector((state) => state.category.categories);

  // TODO:================

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const visibleRows = React.useMemo(() => rows, [rows]);

  React.useEffect(() => {
    // TODO: no need of debounce as all data are fetch already
    dispatch(
      fetchTestimonials({
        enqueueSnackbar,
        page,
      })
    );
  }, [dispatch, refresh, page]);

  // TODO: functions

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  // TODO: delete the page
  const handleDelete = () => {
    dispatch(
      deleteTestimonial({
        id: dataToEdit?.id,
        enqueueSnackbar,
        handleClose: () => setOpenConfirmModal(false),
      })
    );
  };

  // ============
  // console.log(
  //   allCategory?.data?.filter((item) => {
  //     return visibleRows?.some((page) => page.id === item.id);
  //   }),
  //   "DATA TO EDIT"
  // );

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <EnhancedTableToolbar
          title={title}
          numSelected={selected.length}
          showAdd={showAdd}
          showSearch={showSearch}
          showFilter={showFilter}
          showPrint={showPrint}
          setOpenAdd={setOpenAdd}
          search={search}
          setSearch={setSearch}
          refresh={refresh}
          setRefresh={setRefresh}
        />

        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows?.length}
              headCells={headCells}
            />
            <TableBody>
              {(fetchLoading ? [...Array(5)] : rows)?.map((row, index) => {
                const isItemSelected = isSelected(row?.name);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <>
                    {row ? (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.name}
                        selected={isItemSelected}
                        sx={{ cursor: "pointer" }}
                      >
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                          id={labelId}
                        >
                          <Avatar src={row?.image} />
                        </TableCell>
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                        >
                          <span>{row?.title}</span>
                        </TableCell>{" "}
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                        >
                          <span>{row?.name}</span>
                        </TableCell>{" "}
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: row?.content || "---",
                            }}
                          ></span>
                        </TableCell>
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                        >
                          <span>{row?.createdDate}</span>
                        </TableCell>
                        <TableCell
                          style={{
                            color: colors.text,
                          }}
                        >
                          <Stack flexDirection={"row"} gap={2}>
                            <button
                              onClick={() => {
                                setOpenEditModal(true);
                                setDataToEdit(row);
                              }}
                              className="flex items-center p-2 text-sm text-white rounded-lg bg-secondary"
                            >
                              <AiOutlineEdit size={20} />
                            </button>
                            <button
                              onClick={() => {
                                setOpenConfirmModal(true);
                                setDataToEdit(row);
                              }}
                              className="flex items-center p-2 text-sm text-white rounded-lg bg-red"
                            >
                              <MdOutlineDeleteOutline size={20} />
                            </button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableSkeleton key={index} />
                    )}
                  </>
                );
              })}

              {!fetchLoading && (
                <TableNoData isNotFound={visibleRows?.length === 0} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* TODO: edit role modal */}
      <EditDialog
        open={openEditModal}
        title={`Edit Testimonial (${dataToEdit?.title})`}
        handleClose={() => setOpenEditModal(false)}
        maxWidth="lg"
      >
        <Form
          data={dataToEdit}
          isEdit={true}
          handleClose={() => setOpenEditModal(false)}
        />
      </EditDialog>

      {/* TODO: delete confirm modal */}
      <ConfirmDialog
        handleClose={() => setOpenConfirmModal(false)}
        open={openConfirmModal}
        title={`Are you sure, you want to delete page(${dataToEdit?.title})?`}
        action={
          <Button
            loading={deleteLoading}
            disabled={deleteLoading}
            className="bg-primary"
            onClick={handleDelete}
          >
            Confirm
          </Button>
        }
      />
    </>
  );
}
